// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB2KaO_iQLr4U8MoST-y3I4dG377P36D9M",
  authDomain: "boticario-29126.firebaseapp.com",
  databaseURL: "https://boticario-29126-default-rtdb.firebaseio.com",
  projectId: "boticario-29126",
  storageBucket: "boticario-29126.firebasestorage.app",
  messagingSenderId: "765163936573",
  appId: "1:765163936573:web:62116b2af50e3445180354"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app);
